import Logo from '../components/Logo'
import {Link, useLocation} from "react-router-dom";
import { useState, useRef, useEffect } from "react";

const handleScroll = e => {
    const target = e.target.getAttribute('href')
    const place = document.querySelector(target.slice(1))

    if (place){
        e.preventDefault();
        window.scrollTo({
            top: place.offsetTop,
            left: 0,
            behavior: "instant"
        });
    }
};


const Header = () => {
    const IsActive = (link) => {
        let location = useLocation().pathname.split('/');
        return link === location[1]
    }

    const ref = useRef()
    const [showDownload, setShowDownload] = useState(false)
    const [showMobileMenu, setShowMobileMenu] = useState(false)
    const NavIcons = () => {
        if(!showMobileMenu){
            return (
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16"></path></svg>
            )
        }
        return (
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path></svg>
        )
    }

    const Navbar = () => {
        return (
            <div
                className="xl:inline-flex xl:flex-row xl:ml-auto w-full lg:items-center items-start justify-end flex flex-col lg:h-auto" >
                <Link to="/"
                      className={`${IsActive('') ? 'border-gray-600' : 'border-transparent'} border-b-2  lg:inline-flex lg:w-auto w-full block px-4 py-1.5 md:py-3 font-medium text-gray-700 items-center justify-center hover:text-gray-500 hover:border-gray-600`}>
                    <span>Home</span>
                </Link>
                <Link onClick={handleScroll} to="/#about-us"
                      spy="true"
                      smooth="true"
                      className="lg:inline-flex lg:w-auto w-full block px-4 py-1.5 md:py-3 font-medium text-gray-700 items-center justify-center hover:text-gray-500 border-b-2 border-transparent hover:border-gray-600">
                    About us
                </Link>
                <Link to="/passengers"
                      className={`${IsActive('passengers') ? 'border-gray-600' : 'border-transparent'} lg:inline-flex lg:w-auto w-full block px-4 py-1.5 md:py-3 font-medium text-gray-700 items-center justify-center hover:text-gray-500 border-b-2 hover:border-gray-600`}>
                    <span>Passengers</span>
                </Link>
                <Link to="/car-owners"
                      className={`${IsActive('car-owners') ? 'border-gray-600' : 'border-transparent'} lg:inline-flex lg:w-auto w-full block px-4 py-1.5 md:py-3 font-medium text-gray-700 items-center justify-center hover:text-gray-500 border-b-2 hover:border-gray-600`}>
                    <span>Car owners</span>
                </Link>
                <Link to="/trip-cost"
                      className={`${IsActive('trip-cost') ? 'border-gray-600' : 'border-transparent'} lg:inline-flex lg:w-auto w-full block px-4 py-1.5 md:py-3 font-medium text-gray-700 items-center justify-center hover:text-gray-500 border-b-2 hover:border-gray-600`}>
                    <span>Know trip cost</span>
                </Link>
                <Link to="/blogs"
                      className={`${IsActive('blogs') ? 'border-gray-600' : 'border-transparent'} lg:inline-flex lg:w-auto w-full block px-4 py-1.5 md:py-3 font-medium text-gray-700 items-center justify-center hover:text-gray-500 border-b-2 hover:border-gray-600`}>
                    <span>Blogs</span>
                </Link>
            </div>
        )
    }

    useEffect(() => {
        const checkIfClickedOutside = e => {
            if (showDownload && ref.current && !ref.current.contains(e.target)) {
                setShowDownload(false)
            }
        }

        document.addEventListener("mousedown", checkIfClickedOutside)

        return () => {
            document.removeEventListener("mousedown", checkIfClickedOutside)
        }
    }, [showDownload])

    const toggleDownloadDropdown = () => {
        setShowDownload(!showDownload)
    }

    useEffect(() => {
        if(showMobileMenu) {
            document.body.style.overflow = 'hidden'
        }
        else {
            document.body.style.overflow = 'auto'
        }
    }, [showMobileMenu])

    return (
        <div className="w-full fixed z-50">
            <nav className="flex items-center bg-white pt-3 lg:px-12 flex-wrap justify-between">
                <div className="flex items-center justify-between w-full xl:w-56 p-2 md:p-0">
                    <Link to="/" className="p-2 mr-4 inline-flex items-center">
                        <Logo />
                    </Link>
                    <button onClick={() => setShowMobileMenu(!showMobileMenu)} className="text-gray-600 border border-gray-500 inline-flex p-2 rounded xl:hidden ml-auto outline-none" data-target="#navigation">
                        <NavIcons />
                    </button>
                </div>
                <div className='hidden xl:flex justify-end'>
                    <div className="top-navbar w-full xl:inline-flex xl:flex-grow xl:w-auto pr-0 xl:pr-8" id="navigation">
                        <Navbar />
                    </div>
                    <div className="text-left p-2 md:p-0" ref={ref}>
                        <div className="relative ">
                            <button type="button" onClick={toggleDownloadDropdown} className="inline-flex justify-center w-40 xl:w-full rounded-md px-4 py-3 bg-green-app text-sm font-medium text-white focus:outline-none focus:ring-none" id="menu-button">
                                Download Now!
                                <svg className="-mr-1 ml-2 h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd"/></svg>
                            </button>
                        </div>

                        {showDownload && (
                            <div
                                className="origin-top-right absolute right-0 mt-2 w-40 rounded-md shadow-lg bg-white border focus:outline-none"
                                role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabIndex="-1">
                                <div className="py-1" role="none">
                                    <Link to="/car-owners" className="text-gray-700 block px-4 py-2 text-sm hover:bg-gray-600 hover:text-white" role="menuitem">Car Owner's app</Link>
                                    <Link to="passengers" className="text-gray-700 block px-4 py-2 text-sm hover:bg-gray-600 hover:text-white" role="menuitem">Passenger's app</Link>
                                </div>
                            </div>
                        )}

                    </div>
                </div>
                <div className='xl:hidden flex'>
                    <div className={
                        `bg-white h-screen fixed top-0 w-full left-0 transition-transform duration-[1.2s] ease-[ease-in-out]
                        ${showMobileMenu ? "translate-y-[0%]" : "translate-y-[-100%]"}`
                    }>
                        <div className='pt-12 text-right px-4'>
                            <button onClick={() => setShowMobileMenu(!showMobileMenu)} className="text-gray-600 border border-gray-500 inline-flex p-2 rounded xl:hidden ml-auto outline-none" data-target="#navigation">
                                <NavIcons />
                            </button>
                        </div>
                        <div className=''>
                            <Navbar />
                        </div>
                        <div className="text-center mt-6 p-2 md:p-0 relative" ref={ref}>
                            <div className="relative ">
                                <button type="button" onClick={toggleDownloadDropdown} className="inline-flex justify-center w-40 xl:w-full rounded-md px-4 py-3 bg-green-app text-sm font-medium text-white focus:outline-none focus:ring-none" id="menu-button">
                                    Download Now!
                                    <svg className="-mr-1 ml-2 h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd"/></svg>
                                </button>
                            </div>

                            {showDownload && (
                                <div
                                    className="absolute left-1/2 mt-2 w-40 rounded-md shadow-lg bg-white border focus:outline-none"
                                    tabIndex="-1">
                                    <div className="py-1" role="none">
                                        <Link to="/car-owners" className="text-gray-700 block px-4 py-2 text-sm hover:bg-gray-600 hover:text-white" role="menuitem">Car Owner's app</Link>
                                        <Link to="passengers" className="text-gray-700 block px-4 py-2 text-sm hover:bg-gray-600 hover:text-white" role="menuitem">Passenger's app</Link>
                                    </div>
                                </div>
                            )}

                        </div>
                    </div>
                </div>
            </nav>
        </div>
    )
}

export default Header
